import { component } from 'picoapp'
import choozy from 'choozy'
import { on, add, remove, qs, qsa, has } from '@selfaware/martha'

import YouTubePlayer from 'youtube-player'

export default component((node, ctx) => {
  let { audioToggle, mute, unmute, prev, next, channel } = choozy(node)

  let totalTracks = qsa('.js-track', node).length

  const getCurrentPlayer = (dir) => {
    let currentTrack
    let currentIndex = parseInt(qs('.js-track.active', node).dataset.index)

    if (dir == -1) {
      currentTrack =
        currentIndex == 1
          ? qs(`.js-track[data-index="${totalTracks}"]`, node)
          : qs(`.js-track[data-index="${currentIndex - 1}"]`, node)
    } else if (dir == 1) {
      currentTrack =
        currentIndex == totalTracks
          ? qs(`.js-track[data-index="1"]`, node)
          : qs(`.js-track[data-index="${currentIndex + 1}"]`, node)
    } else {
      currentTrack = qs('.js-track.active')
    }

    remove(qs('.js-track.active', node), 'active')
    add(currentTrack, 'active')

    var audioPlayer = SC.Widget(qs('iframe', currentTrack))

    audioPlayer.bind(SC.Widget.Events.FINISH, () => {
      // When the track finishes, play the next track
      toggleAudio(true, 1)
    })

    channel.innerHTML = `CH. ${currentTrack.dataset.index}`

    return audioPlayer
  }

  const toggleAudio = (playAudio, dir) => {
    let currentPlayer = getCurrentPlayer(dir)

    if (playAudio) {
      currentPlayer.play()

      add(mute, 'hidden')
      remove(unmute, 'hidden')

      ctx.hydrate({ audioPlayed: true })
    } else {
      currentPlayer.pause()

      remove(mute, 'hidden')
      add(unmute, 'hidden')
    }
  }

  on(audioToggle, 'click', () => {
    if (has(unmute, 'hidden')) {
      toggleAudio(true)
    } else {
      toggleAudio(false)
    }
  })

  ctx.on('game', () => {
    if (ctx.getState().game == 'created' && !ctx.getState().audioPlayed) {
      toggleAudio(true)
    }
  })

  on(prev, 'click', () => {
    toggleAudio(true, -1)
  })

  on(next, 'click', () => {
    toggleAudio(true, 1)
  })

  return () => {}
})
